import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from 'react-jss';
import SLUGS from 'resources/slugs';
import { IconArrowRight, IconEdm } from 'assets/icons';

function AlmostThereComponent({ email, errorMessage, resendEmail }) {
    const theme = useTheme();

    async function onClickResend() {
        try {
            await resendEmail(email);
        } catch (ex) {
            console.log(ex.message);
        }
    }

    return (
        <>
            <h1>Create Account</h1>
            {errorMessage && <span className='signup-error-message'>{errorMessage}</span>}
            <IconEdm width={63} height={60} fill={theme.color.resultsIconColor} />
            <h3>You’re Almost There!</h3>
            <span id='signup_verification_email'>We’ve sent a verification email to {email}.</span>
            <span>Follow the link in the email to finish creating your account!</span>
            <button
                className='flex items-center signup-link-login signup-link-almost-there'
                onClick={onClickResend}
            >
                <span>Resend Verification Email</span>
                <div>
                    <IconArrowRight />
                </div>
            </button>
            <Link
                className='flex items-center signup-link-login signup-link-almost-there'
                to={SLUGS.login}
            >
                <span>Return Home</span>
                <div>
                    <IconArrowRight />
                </div>
            </Link>
        </>
    );
}

export default AlmostThereComponent;
